import { useSwipable } from "client/hooks/utils/useSwipable";
import { useRef, useState } from "react";
import { ColorScheme } from "../useColorHarmonies";

export const useTabs = (setTab: (tab: ColorScheme) => void) => {
    const sliderRef = useRef<HTMLDivElement>(null);
    useSwipable(sliderRef);
    const [currentIndex, setCurrentIndex] = useState(1);

    const handleClick = (tab: ColorScheme, index: number) => {
        setTab(tab);
        handleScroll(index, currentIndex);
        setCurrentIndex(index);
    };

    const handleScroll = (index: number, currentIndex: number) => {
        if (index < 2) {
            sliderRef.current?.scrollTo({
                behavior: "smooth",
                left: 0,
            });
        } else if (index === 2) {
            sliderRef.current?.scrollTo({
                behavior: "smooth",
                left: sliderRef.current.getBoundingClientRect().width / 2,
            });
        } else if (index === 3 && currentIndex === 4) {
            // going from last to second last
            sliderRef.current?.scrollTo({
                behavior: "smooth",
                left: sliderRef.current.getBoundingClientRect().width - 50,
            });
        } else {
            sliderRef.current?.scrollTo({
                behavior: "smooth",
                left: sliderRef.current.getBoundingClientRect().width + 50,
            });
        }
    };

    return { sliderRef, handleClick };
};
